import { useState } from "react";
import "./BurgerMenu.css";

// Menu burger des comptes connectés. Les entrées s'adaptent au rôle :
// Facturations et Abonnement n'existent que là où ils ont un sens — un
// commercial n'a pas d'abonnement, un employé n'a pas à voir les montants.
function BurgerMenu({ user, onNavigate, onLogout }) {
  const [open, setOpen] = useState(false);

  const go = (page) => {
    setOpen(false);
    onNavigate(page);
  };

  const isUser = user.role === "User";
  const isAdmin = user.role === "Admin";

  return (
    <div className="bm">
      <button
        className={`bm-btn${open ? " bm-btn-open" : ""}`}
        onClick={() => setOpen(!open)}
        aria-label="Menu"
        aria-expanded={open}
      >
        <span />
        <span />
        <span />
      </button>

      {open && (
        <>
          {/* Ferme le menu au clic n'importe où ailleurs */}
          <div className="bm-overlay" onClick={() => setOpen(false)} />
          <nav className="bm-menu">
            <span className="bm-user">{user.surname} {user.name}</span>
            <button onClick={() => go("account")}>Mon compte</button>
            {isUser && !!user.organization_id && (
              <button onClick={() => go("billing")}>Facturations</button>
            )}
            {isAdmin && (
              <button onClick={() => go("invoices")}>Facturations</button>
            )}
            {isUser && (
              <button onClick={() => go("subscription")}>Abonnement</button>
            )}
            {/* PDF à déposer dans frontend/public/mode-emploi.pdf */}
            <a
              className="bm-download"
              href="/mode-emploi.pdf"
              download="Mode d'emploi - Fidelity Card.pdf"
              onClick={() => setOpen(false)}
            >
              Télécharger le mode d'emploi
            </a>
            <button
              className="bm-logout"
              onClick={() => {
                setOpen(false);
                onLogout();
              }}
            >
              Se déconnecter
            </button>
          </nav>
        </>
      )}
    </div>
  );
}

export default BurgerMenu;
